<template>
  <div class="flex min-h-screen flex-col">
    <div
      class="grid h-screen min-h-full bg-white text-[#454545] lg:grid-cols-2"
    >
      <div class="flex flex-col items-center justify-center">
        <div class="w-96 max-w-xl">
          <div class="flex items-center gap-2 transition duration-1000">
            <NuxtLink
              class="text-xl font-bold text-gray-900"
              to="/"
            >
              <VeridisLogo />
            </NuxtLink>
          </div>
          <div class="space-y-6">
            <h2 class="mt-6 text-left text-3xl font-semibold">
              Log in
            </h2>
            <div class="space-y-4">
              <div>
                <label
                  for="email"
                  class="block text-sm font-medium"
                >Email address</label>
                <div class="mt-1">
                  <input
                    name="email"
                    type="email"
                    autocomplete="email"
                    required=""
                    class="w-full border border-neutral-300 bg-transparent px-3 py-2 shadow-sm focus:border-neutral-300 sm:text-sm"
                  >
                </div>
              </div>
              <div>
                <label
                  for="password"
                  class="block text-sm font-medium"
                >Password</label>
                <div class="mt-1">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autocomplete="current-password"
                    required=""
                    class="w-full border border-neutral-300 bg-transparent px-3 py-2 shadow-sm focus:border-neutral-300 sm:text-sm"
                  >
                </div>
              </div>
              <!---->
              <div>
                <button
                  class="h-10 w-full rounded-md border-2 border-green-800/50 bg-green-700 text-sm font-medium text-white"
                  type="submit"
                >
                  Log in
                </button>
              </div>
            </div>
            <div class="flex justify-between text-xs">
              <div>
                Don't have an account?
                <NuxtLink
                  to="/register"
                  class="font-semibold hover:underline"
                >Register</NuxtLink>
              </div>
              <div>
                <a
                  class="font-medium"
                  target="_blank"
                  href="https://zunocarbon.com"
                >Powered by Zuno Carbon</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bank-note hidden bg-neutral-100 lg:block" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginComponent',
}
</script>
